export default __webpack_public_path__ + "static/media/Candara_Bold.1e5d3f06.ttf";